import React from "react";
import Chart from "react-apexcharts";
import "./dashboard.css";

const PatientDashboard = () => {

  // Upcoming Appointments (Line Chart)
  const appointmentsChart = {
    series: [
      {
        name: "Appointments",
        data: [1, 2, 1, 3, 2, 2, 1] // Example weekly data
      }
    ],
    options: {
      chart: { type: "line", toolbar: { show: false } },
      colors: ["#2F80ED"],
      xaxis: { categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] },
      stroke: { curve: "smooth", width: 3 },
      dataLabels: { enabled: false }
    }
  };

  // Completed vs Pending Visits (Donut)
  const visitStatusChart = {
    series: [5, 2], // Completed, Pending
    options: {
      chart: { type: "donut" },
      labels: ["Completed", "Pending"],
      colors: ["#27AE60", "#F2994A"],
      legend: { position: "bottom" }
    }
  };

  // Service Usage (Bar Chart)
  const serviceUsageChart = {
    series: [
      {
        name: "Times Used",
        data: [3, 2, 1] // Physiotherapy, Nursing, Elderly care
      }
    ],
    options: {
      chart: { type: "bar", toolbar: { show: false } },
      plotOptions: { bar: { borderRadius: 6, columnWidth: "50%" } },
      xaxis: { categories: ["Physiotherapy", "Home Nursing", "Elderly Care"] },
      colors: ["#56CCF2"]
    }
  };

  return (
    <div className="dashboard">
      <h2>Patient Dashboard</h2>

      {/* Summary Cards */}
      <div className="cards">
        <div className="card">📅 Upcoming Visits: 2</div>
        <div className="card">✅ Completed Visits: 5</div>
        <div className="card">🏠 Active Services: 3</div>
      </div>

      {/* Charts */}
      <div className="charts">
        <div className="chart-card">
          <h3>Appointments This Week</h3>
          <Chart
            options={appointmentsChart.options}
            series={appointmentsChart.series}
            type="line"
            height={250}
          />
        </div>

        <div className="chart-card">
          <h3>Visit Status</h3>
          <Chart
            options={visitStatusChart.options}
            series={visitStatusChart.series}
            type="donut"
            height={250}
          />
        </div>

        <div className="chart-card">
          <h3>Service Usage</h3>
          <Chart
            options={serviceUsageChart.options}
            series={serviceUsageChart.series}
            type="bar"
            height={250}
          />
        </div>
      </div>
    </div>
  );
};

export default PatientDashboard;
